export default {
  GET_QUOTE(state, payload) {
    state.quotes = payload;
  },
  SELECT_UPDATE_QUOTE(state, payload) {
    state.selectedquotes = payload;
  },
};
